<template>
  <div class="por-exames">
    <ProcedimentosSaude
      :title="exame"
      :termo-consulta="exame"
      :breadcrumb="breadcrumb"
      :urls="urls"
      :tipo="'exames'"
    >
      <template slot="header-slot">
        <div class="col-xs-12">
          <p>
            Aqui você encontra as solicitações agendadas para realização do
            exame <span class="destaque-header">{{ exame }}</span
            >.
          </p>
        </div>
      </template>
    </ProcedimentosSaude>
  </div>
</template>

<script>
import { ProcedimentosSaude } from '../../../components'

export default {
  components: { ProcedimentosSaude },
  data() {
    return {
      exame: '',
      urls: {
        espera: 'procedimentos-saude/lista-exames',
        agendados: 'procedimentos-saude/lista-exames-agendados'
      }
    }
  },
  created() {
    const { exame } = this.$route.params
    this.exame = exame
  },
  computed: {
    breadcrumb() {
      return [
        {
          label: 'Minha Saúde',
          named_link: { name: 'procedimentos_saude' }
        },
        {
          label: this.exame
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/procedimentos_saude/PorExame.vue